export const PERMISSION_VIEW_STUDENT_INTELLIGENCE = 'ViewStudentIntelligence';

export const PERMISSION_MANAGE_SUPER_STUDENTS = 'ManageSuperStudents';

export const PERMISSION_TRIGGER_AI_GRADING = 'TriggerAIGrading';

export const PERMISSION_OVERRIDE_GRADE = 'OverrideGrade';

export const PERMISSION_SEND_SMS_CAMPAIGN = 'SendSmsCampaign';

export const PERMISSION_SEND_IMPACT_REPORT = 'SendImpactReport';

export const PERMISSION_MANAGE_JOB_DIGEST = 'ManageJobDigest';

export const PERMISSION_ADD_JOBS = 'AddJobs';

export const PERMISSION_MANAGE_ADMISSIONS = 'ManageAdmissions';

export const PERMISSION_MANAGE_COHORT_ALERTS = 'ManageCohortAlerts';

export const PERMISSION_MANAGE_FORMS = 'ManageForms';

export function canViewStudentIntelligence(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_VIEW_STUDENT_INTELLIGENCE);
}

/** Super Students whitelist, enrollments, and cohort invites — Admin / SuperAdmin only by default. */
export function canManageSuperStudents(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_MANAGE_SUPER_STUDENTS);
}

export function canTriggerAIGrading(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_TRIGGER_AI_GRADING);
}

/** Manual grade override on an AI-graded submission — Admin / SuperAdmin only by default. */
export function canOverrideGrade(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_OVERRIDE_GRADE);
}

/** Bulk SMS campaigns — SuperAdmin always; other roles need SendSmsCampaign. */
export function canSendSmsCampaign(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_SEND_SMS_CAMPAIGN);
}

/** Emailing impact reports to outside addresses — SuperAdmin always; others need SendImpactReport. */
export function canSendImpactReport(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_SEND_IMPACT_REPORT);
}

/** Job recommendations to graduates — SuperAdmin always; others need ManageJobDigest. */
export function canManageJobDigest(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_MANAGE_JOB_DIGEST);
}

/** Admissions from forms (accepted applicants) — SuperAdmin always; others need ManageAdmissions. */
export function canManageAdmissions(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_MANAGE_ADMISSIONS);
}

/** Cohort settings (e.g. specialization qualification) — SuperAdmin always; others need UpdateCohort. */
export function canUpdateCohort(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes('UpdateCohort');
}

/** Learner support actions (e.g. specialization approval) — SuperAdmin always; others need UpdateStudent. */
export function canUpdateStudent(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes('UpdateStudent');
}

/** Assignment reminders for a cohort — SuperAdmin always; others need ManageCohortAlerts. */
export function canManageCohortAlerts(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_MANAGE_COHORT_ALERTS);
}

/** Forms assigned to cohorts — SuperAdmin always; others need ManageForms. */
export function canManageForms(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return permissions.includes(PERMISSION_MANAGE_FORMS);
}

/** Adding jobs for the digest — SuperAdmin always; others need AddJobs or ManageJobDigest. */
export function canAddJobs(permissions, role) {
  if (role === 'SuperAdmin') {
    return true;
  }
  if (!Array.isArray(permissions)) {
    return false;
  }
  return (
    permissions.includes(PERMISSION_ADD_JOBS) ||
    permissions.includes(PERMISSION_MANAGE_JOB_DIGEST)
  );
}
